import { Component, Input, OnInit } from '@angular/core';
import { LocationV2Dto } from 'src/app/api/exa';
import { LocationService } from 'src/app/services/location.service';
import { MarkerTypeEnum } from '../../../enums/marker-type-enum';

@Component({
  selector: 'drawer-content-location-info',
  templateUrl: './location-info.component.html',
  styleUrls: ['./location-info.component.scss'],
})
export class LocationInfoComponent implements OnInit {
  @Input('location') location: LocationV2Dto;

  locationLatitude = null;
  locationLongitude = null;

  googleMapsUrl: string;
  poiLat: any;
  poiLng: any;

  constructor(private locationService: LocationService) {}

  ngOnInit() {}

  onLocationClick(location) {
    this.locationLatitude = location.geometry.centroid.latitude;
    this.locationLongitude = location.geometry.centroid.longitude;

    const locationNav = this.locationService.getLocationById(location.id).geometry.pois;

    if (locationNav == null) {
    } else if (locationNav) {
      locationNav.forEach((el) => {
        if (el.type == MarkerTypeEnum.ENTRANCE) {
          this.poiLat = el.coordinate.latitude;
          this.poiLng = el.coordinate.longitude;
        }
      });
    }
  }

  navigateToLocation() {
    this.onLocationClick(this.location);

    const poiLat = this.poiLat;
    const poiLng = this.poiLng;

    if (poiLat && poiLng) {
      this.googleMapsUrl = encodeURI(`https://www.google.com/maps/dir/?api=1&destination=${poiLat}+${poiLng}&travelmode=driving`);
      this.poiLat = null;
      this.poiLng = null;
    } else {
      this.googleMapsUrl = encodeURI(
        `https://www.google.com/maps/dir/?api=1&destination=${this.locationLatitude}+${this.locationLongitude}&travelmode=driving`
      );
    }
    window.open(encodeURI(this.googleMapsUrl), '_system');
  }
}
